/** FC255 pure Quick Intake. Deliberately separate from FC252 legacy receipt APIs. */
import axios from 'axios';
const base = '/api/playable_intake/pure/batches';
export const listBatches = () => axios.get(base);
export const createBatch = (data) => axios.post(base, data);
export const readRows = (id) => axios.get(`${base}/${id}/rows`);
export const stageCard = (id, data) => axios.post(`${base}/${id}/rows`, data);
export const setBatchCost = (id, data) => axios.put(`${base}/${id}/batch_cost`, data);
export const getBatchCostAudit = (id) => axios.get(`${base}/${id}/batch_cost/audit`);
export const correctRow = (id, row, data) => axios.patch(`${base}/${id}/rows/${row}`, data);
export const voidRow = (id, row, data) => axios.delete(`${base}/${id}/rows/${row}`, { data });
export const readAudit = (id, row) => axios.get(`${base}/${id}/rows/${row}/audit`);
export const finaliseBatch = (id, data) => axios.post(`${base}/${id}/finalise`, data);
export const findCards = (query) => axios.get('/api/cards/lookup', { params: { q: query, limit: 24, high_only: 0 } });
